import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    border: PropTypes.bool,
    number: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'table',
    border: false,
    number: false,
};

class Table extends Abstrap {

    getClassNameSchema() {
        const {
            border,
            className,
            number,
        } = this.props;
        return [
            'c-table',
            border ? 'c-table_border' : false,
            number ? 'c-table_number' : false,
            className,
        ];
    }

}

Table.propTypes = propTypes;

Table.defaultProps = defaultProps;

export default Table;
